import React, { useState, useEffect } from 'react';
import { FaDiscord, FaVoteYea, FaTerminal, FaExternalLinkAlt, FaServer, FaUsers } from 'react-icons/fa';
import '../App.css';

const App = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [menuOpen]);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const questions = [
    {
      q: "Midas ücretli mi?",
      a: "Hayır, Midas'ın bütün komutları ve özellikleri tamamen ücretsizdir."
    },
    {
      q: "Verilerim güvende mi?",
      a: "Midas, kullanıcı gizliliğine en üst düzeyde önem verir. Kullanıcı verilerini asla kalıcı olarak kayıt etmez ve üçüncü taraflarla paylaşmaz."
    },
    {
      q: "Botu nasıl sunucuma eklerim?",
      a: "Üst menüdeki \"Sunucuna Ekle\" butonuna tıklayarak gerekli izinleri verip hızlıca ekleyebilirsiniz."
    }
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="faq-section">
      <h2 className="faq-title">Sıkça Sorulan <span>Sorular</span></h2>
      <div className="faq-container">
        {questions.map((item, index) => (
          <div 
            key={index} 
            className={`faq-item ${activeIndex === index ? 'active' : ''}`}
            onClick={() => toggleFAQ(index)}
          >
            <div className="faq-question">
              {item.q}
              <span className="faq-arrow">{activeIndex === index ? '−' : '+'}</span>
            </div>
            <div className="faq-answer">
              <p>{item.a}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

  return (
    <div className="modern-body">
      {/* Header / Navbar */}
      <header className="glass-header">
        <div className="title">
          <img src="https://r.resimlink.com/6gMxa9P.png" alt="Midas" className="logo" />
          <h1>Midas</h1>
        </div>

        <div className="menu-icon" onClick={toggleMenu}>
          <div className={menuOpen ? "bar open" : "bar"}></div>
          <div className={menuOpen ? "bar open" : "bar"}></div>
          <div className={menuOpen ? "bar open" : "bar"}></div>
        </div>

        <nav className={menuOpen ? "nav-menu active" : "nav-menu"}>
          <a href="/komutlar"><FaTerminal /> Komutlar</a>
          <a href="https://discord.gg/PfAdzWsjVN" target="_blank" rel="noreferrer">
            <FaExternalLinkAlt /> Destek Sunucusu
          </a>
        </nav>
      </header>

      {/* Hero / Landing Section */}
      <main className="hero-container">
        <div className="hero-content">
          <h2 className="hero-title">Sunucunuzu <span>Midas</span> ile Taçlandırın.</h2>
          <p className="hero-subtitle">
            Gelişmiş ekonomi sistemi, moderasyon araçları ve eğlence komutlarıyla 
            Discord topluluğunuzu bir üst seviyeye taşıyın.
          </p>
          
          <div className="hero-buttons">
            <a className="btn btn-primary" href="https://discord.com/oauth2/authorize?client_id=974770645013528597&permissions=8&integration_type=0&scope=bot">
              <FaDiscord /> Sunucuna Ekle
            </a>
            <a className="btn btn-secondary" href="https://top.gg/bot/974770645013528597/vote">
              <FaVoteYea /> Oy Ver
            </a>
          </div>
        </div>

        <div className="hero-image">
          <img src="https://r.resimlink.com/6gMxa9P.png" alt="Midas Large" className="floating logo-smooth" />
        </div>
      </main>

    <section className="stats-section">
      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon-wrapper">
            <FaServer className="stat-icon" />
          </div>
          <h3 className="stat-value">48</h3>
          <p className="stat-label">Sunucu</p>
          <div className="stat-bar"></div>
        </div>

        <div className="stat-card">
          <div className="stat-icon-wrapper">
            <FaUsers className="stat-icon" />
          </div>
          <h3 className="stat-value">91.501</h3>
          <p className="stat-label">Kullanıcı</p>
          <div className="stat-bar"></div>
        </div>
      </div>
    </section>

      <FAQ />
          
      <footer className="simple-footer">
        <p>© 2026 Midas Discord Bot - Tüm Hakları Saklıdır.</p>
      </footer>
    </div>
  );
}

export default App;
